import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M7 2v11h3v9l7-12h-4l4-8z"
}), 'FlashOn');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FlashOn.js
// module id = 3724
// module chunks = 2